import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { Textarea } from 'components/fields'

@injectIntl
class AcceptActivityForm extends Component {
  static propTypes = {
    intl: PropTypes.object,
    isAccept: PropTypes.bool,
    onReject: PropTypes.func
  }

  static defaultProps = {
    prefix: null,
    storeRemoved: false
  }

  render() {
    const { intl, onReject, isAccept } = this.props

    return (
      <div>
        {!isAccept && (
          <div>
            <div className="row">
              <div className="col-xs-12">
                <div className="row" style={{ marginTop: 50 }}>
                  <div className="col-xs-12">
                    <p className="note">
                      Or don't agree? You can{' '}
                      <span className="link" onClick={onReject}>
                    reject activity
                  </span>.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {isAccept && (
          <Textarea
            name="reason"
            label="Reason of rejection"
            intlKey="label.assessor_rejection_reason"
            placeHolder={intl.formatMessage({
              defaultMessage:
                "Please fill in the reason if you cannot be an assessor for this participant.",
              id: 'label.participant_rejection_reason_desc'
            })}
          />
        )}
      </div>
    )
  }
}

export default AcceptActivityForm
